// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Report_wrapper__3AOOA"};